export default __webpack_public_path__ + "static/media/discover.2f096685.svg";